<style lang="scss" scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
</style>

<template>
  <td>
    <div
      ref="dropdown"
      class="dropdown"
      :class="{ show: show, dropup: index > 10, dropleft: true }"
    >
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <a
          v-if="emailKnown"
          target="_blank"
          class="dropdown-item"
          :href="customerProfileCardIndexLink"
        >
          Mitgliederkartei
        </a>
        <div v-else class="dropdown-item">Email-Adresse unbekannt</div>
        <div
          v-if="emailKnown"
          @click="$modal.show(messageFromSupportModalName)"
          class="dropdown-item"
        >
          Nachricht schreiben von SupportProfile
        </div>
        <div
          v-if="userHasRestriction"
          @click="removeUserEmailLock()"
          class="dropdown-item"
        >
          E-Mail-Sperre aufheben
        </div>
      </div>
    </div>

    <modal :name="messageFromSupportModalName">
      <section class="p-3">
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="Nachricht ..."
            v-model="supportMessage"
          ></textarea>
        </div>
        <button
          @click="sendSupportMessage()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Senden
        </button>
      </section>
    </modal>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  props: ["model", "tableId", "index"],
  data() {
    return {
      show: false,
      disableModalActions: false,
      fakeID: 1,
      supportMessage: ""
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  methods: {
    sendSupportMessage() {
      this.disableModalActions = true;
      this.$http;
      this.$store
        .dispatch("message/create", {
          url: "/api/v1/message",
          data: {
            body: this.supportMessage,
            receiver_id: this.model.customerProfile.id,
            sender_id: Laravel.support.id,
            type: 5
          }
        })
        .then(() => {
          this.$notify({
            title: `${this.model.customerProfile.name} hat eine Support Nachricht erhalten`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
          this.show = false;
          this.$modal.hide(this.messageFromSupportModalName);
        });
    },
    removeUserEmailLock() {
      this.$http
        .post("/api/v1/emailBounce/update", {
          user_id: this.model.user_id,
          bounced_email_address: this.model.bounced_email_address,
          restriction: false
        })
        .then(() => {
          this.$notify({
            title: `E-Mail-Sperre für ${this.model.bounced_email_address} wurde aufgehoben`,
            type: "success"
          });
          this.$bus.$emit("refresh-table");
        });
      this.show = false;
    }
  },
  computed: {
    modalPrefix() {
      return this.model.id;
    },
    customerProfileCardIndexLink() {
      return "/mitglieder/kartei/" + this.model.customerProfile.id;
    },
    messageFromSupportModalName() {
      return `${this.modalPrefix}-message-from-support`;
    },
    userHasRestriction() {
      return this.model.user_email_restriction;
    },
    emailKnown() {
      return (
        this.model.customerProfile &&
        this.model.customerProfile.id !== Laravel.support.id
      );
    }
  }
};
</script>
